
export function functionA() {
  console.log("Hello, World!");
};
